import React, { useState } from 'react'
import useAssetLiveData from './useAssetLiveData'
import AssetCardDialogs from './AssetCardDialogs'
import AssetCardByGroupView from './AssetCardByGroupView'

/**
 * AssetCardByGroup — composition root of the redesigned by-cell grid card (HU-04).
 *
 * PO feedback: the grid card now carries its own action buttons (physical parts,
 * manage location, documents, calendar) — the same ones the detail already offers —
 * instead of a single "open diagnostics" trigger, so mirrors `AssetCard.jsx`'s
 * pattern again: wires the SHARED, unmodified `AssetCardDialogs` (dialogs/actions/
 * permissions, RN17/RN18) + the SHARED `useAssetLiveData` (data) to the NEW,
 * duplicated presentation `AssetCardByGroupView`. Only the DATA/LOGIC layer is shared
 * with the pre-existing screen (PO directive) — the visuals are entirely independent
 * of `AssetCardView.jsx`.
 *
 * Memoized: the screen re-renders on every 2s poll tick; the setIntervalData identity
 * guards + the flatten cache keep this card's props reference-stable while its device
 * did not change, so only the cards whose data actually moved re-render.
 */
function AssetCardByGroup ({ device, locations = [], mainImageInfo = {}, refreshToken, onOpenDetail, onItemClick = () => {}, onMainImageChange = () => {}, viewMode = 'compact' }) {
  const [partsDialogOpen, setPartsDialogOpen] = useState(false)

  const {
    deviceInfo,
    planificationLocations,
    loadStoragesByDevice,
    production
  } = useAssetLiveData(device, refreshToken, partsDialogOpen, viewMode === 'production')

  return (
    <AssetCardDialogs
      device={device}
      locations={locations}
      planificationLocations={planificationLocations}
      loadStoragesByDevice={loadStoragesByDevice}
      onPartsDialogOpenChange={setPartsDialogOpen}
      onItemClick={onItemClick}
      onMainImageChange={onMainImageChange}
    >
      {(actions) => (
        <AssetCardByGroupView device={device} deviceInfo={deviceInfo} actions={actions} onOpenDetail={onOpenDetail} locations={locations} mode={viewMode} production={production} mainImageInfo={mainImageInfo} />
      )}
    </AssetCardDialogs>
  )
}

export default React.memo(AssetCardByGroup)
